var map = {
	"./ASEAN.png": "f490",
	"./Afghanistan.png": "7981",
	"./African Union.png": "f4be",
	"./Albania.png": "dd6f",
	"./Algeria.png": "6972",
	"./American Samoa.png": "654a",
	"./Andorra.png": "6cb8",
	"./Angola.png": "bb23",
	"./Anguilla.png": "f220",
	"./Antarctica.png": "1f2b",
	"./Antigua & Barbuda.png": "d642",
	"./Arab League.png": "84d6",
	"./Argentina.png": "b7fc",
	"./Armenia.png": "336c",
	"./Aruba.png": "abe8",
	"./Australia.png": "affb",
	"./Austria.png": "e9a0",
	"./Azerbaijan.png": "30bb",
	"./Bahamas.png": "f79f",
	"./Bahrain.png": "c1e7",
	"./Bangladesh.png": "80d3",
	"./Barbados.png": "866e",
	"./Belarus.png": "df94",
	"./Belgium.png": "bc48",
	"./Belize.png": "1552",
	"./Benin.png": "3c64",
	"./Bermuda.png": "733a",
	"./Bhutan.png": "5a5d",
	"./Bolivia.png": "ab3e",
	"./Bosnia & Herzegovina.png": "7dfb",
	"./Botswana.png": "7183",
	"./Brazil.png": "afc0",
	"./Brunei.png": "5f02",
	"./Bulgaria.png": "34fd",
	"./Burkina Faso.png": "d6f8",
	"./Burundi.png": "7fdf",
	"./CARICOM.png": "e3c9",
	"./CIS.png": "e108",
	"./Cambodja.png": "e70b",
	"./Cameroon.png": "1d6a",
	"./Canada.png": "2290",
	"./Cape Verde.png": "4395",
	"./Cayman Islands.png": "b6fa",
	"./Central African Republic.png": "90c5",
	"./Chad.png": "9a8c",
	"./Chile.png": "0c66",
	"./China.png": "8b3d",
	"./Colombia.png": "9c05",
	"./Commonwealth.png": "0948",
	"./Comoros.png": "6bb9",
	"./Congo-Brazzaville.png": "b8fd",
	"./Congo-Kinshasa(Zaire).png": "24df",
	"./Cook Islands.png": "2472",
	"./Costa Rica.png": "2d7e",
	"./Cote d'Ivoire.png": "0c08",
	"./Croatia.png": "9009",
	"./Cuba.png": "e4a6",
	"./Cyprus.png": "257a",
	"./Czech Republic.png": "71c5",
	"./Denmark.png": "5442",
	"./Djibouti.png": "90bc",
	"./Dominica.png": "9609",
	"./Dominican Republic.png": "15c3",
	"./Ecuador.png": "7f16",
	"./Egypt.png": "cc5c",
	"./El Salvador.png": "7ee0",
	"./England.png": "d810",
	"./Equatorial Guinea.png": "df0a",
	"./Eritrea.png": "f871",
	"./Estonia.png": "4017",
	"./Ethiopia.png": "8176",
	"./European Union.png": "60dd",
	"./Faroes.png": "72e3",
	"./Fiji.png": "493e",
	"./Finland.png": "f68e",
	"./France.png": "9908",
	"./Gabon.png": "8ce9",
	"./Gambia.png": "cae2",
	"./Georgia.png": "dd9a",
	"./Germany.png": "7bb1",
	"./Ghana.png": "f089",
	"./Gibraltar.png": "707d",
	"./Greece.png": "1c6e",
	"./Greenland.png": "4d86",
	"./Grenada.png": "e22a",
	"./Guadeloupe.png": "1750",
	"./Guam.png": "9ecd",
	"./Guatemala.png": "704f",
	"./Guernsey.png": "ac60",
	"./Guinea-Bissau.png": "8dab",
	"./Guinea.png": "1b68",
	"./Guyana.png": "d4d0",
	"./Haiti.png": "d6c9",
	"./Honduras.png": "f013",
	"./Hong Kong.png": "f38c",
	"./Hungary.png": "960c",
	"./Iceland.png": "4eb1",
	"./India.png": "5eb9",
	"./Indonezia.png": "7576",
	"./Iran.png": "d1d9",
	"./Iraq.png": "d305",
	"./Ireland.png": "63b2",
	"./Islamic Conference.png": "097c",
	"./Isle of Man.png": "6499",
	"./Israel.png": "a450",
	"./Italy.png": "5e18",
	"./Jamaica.png": "e6fa",
	"./Japan.png": "91b6",
	"./Jersey.png": "ba0c",
	"./Jordan.png": "5228",
	"./Kazakhstan.png": "dc19",
	"./Kenya.png": "1e81",
	"./Kiribati.png": "676b",
	"./Kosovo.png": "e78b",
	"./Kuwait.png": "16eb",
	"./Kyrgyzstan.png": "9d70",
	"./Laos.png": "6fc9",
	"./Latvia.png": "a96a",
	"./Lebanon.png": "b28e",
	"./Lesotho.png": "abd4",
	"./Liberia.png": "8571",
	"./Libya.png": "5c8d",
	"./Liechtenshein.png": "f314",
	"./Lithuania.png": "dbeb",
	"./Luxembourg.png": "4909",
	"./Macao.png": "e436",
	"./Macedonia.png": "0a27",
	"./Madagascar.png": "36ac",
	"./Malawi.png": "2339",
	"./Malaysia.png": "34d5",
	"./Maldives.png": "0acc",
	"./Mali.png": "121b",
	"./Malta.png": "627c",
	"./Marshall Islands.png": "773b",
	"./Martinique.png": "3dea",
	"./Mauritania.png": "c03f",
	"./Mauritius.png": "2d28",
	"./Mexico.png": "cc53",
	"./Micronesia.png": "83a2",
	"./Moldova.png": "0812",
	"./Monaco.png": "d65b",
	"./Mongolia.png": "be6a",
	"./Montenegro.png": "2f30",
	"./Montserrat.png": "27b9",
	"./Morocco.png": "ddef",
	"./Mozambique.png": "7f98",
	"./Myanmar(Burma).png": "ca7d",
	"./NATO.png": "e65a",
	"./Namibia.png": "8e26",
	"./Nauru.png": "df02",
	"./Nepal.png": "495b",
	"./Netherlands Antilles.png": "15e0",
	"./Netherlands.png": "c0bb",
	"./New Caledonia.png": "5312",
	"./New Zealand.png": "132a",
	"./Nicaragua.png": "ec7a",
	"./Niger.png": "a241",
	"./Nigeria.png": "d55b",
	"./North Korea.png": "1b0f",
	"./Northern Cyprus.png": "d855",
	"./Northern Ireland.png": "61d3",
	"./Norway.png": "1de2",
	"./OPEC.png": "6dbe",
	"./Olimpic Movement.png": "4a2d",
	"./Oman.png": "4e8d",
	"./Pakistan.png": "6b5d",
	"./Palau.png": "549a",
	"./Palestine.png": "60b2",
	"./Panama.png": "bbe2",
	"./Papua New Guinea.png": "b339",
	"./Paraguay.png": "a327",
	"./Peru.png": "0f9e",
	"./Philippines.png": "b86e",
	"./Poland.png": "a110",
	"./Portugal.png": "570d",
	"./Puerto Rico.png": "c600",
	"./Qatar.png": "5847",
	"./Red Cross.png": "9382",
	"./Reunion.png": "cb04",
	"./Romania.png": "39a6",
	"./Russian Federation.png": "e2db",
	"./Rwanda.png": "7852",
	"./Saint Lucia.png": "8828",
	"./Samoa.png": "a45a",
	"./San Marino.png": "8145",
	"./Sao Tome & Principe.png": "6b71",
	"./Saudi Arabia.png": "89db",
	"./Scotland.png": "9d38",
	"./Senegal.png": "083b",
	"./Serbia.png": "419a",
	"./Seychelles.png": "b9c9",
	"./Sierra Leone.png": "e0ed",
	"./Singapore.png": "7f52",
	"./Slovakia.png": "fef6",
	"./Slovenia.png": "7a4d",
	"./Solomon Islands.png": "99e3",
	"./Somalia.png": "fb60",
	"./Somaliland.png": "d1c3",
	"./South Africa.png": "87c4",
	"./South Korea.png": "a040",
	"./Spain.png": "7e23",
	"./Sri Lanka.png": "8b63",
	"./St Kitts & Nevis.png": "b5bb",
	"./St Vincent & the Grenadines.png": "ac21",
	"./Sudan.png": "512c",
	"./Suriname.png": "3058",
	"./Swaziland.png": "2706",
	"./Sweden.png": "5378",
	"./Switzerland.png": "b613",
	"./Syria.png": "f184",
	"./Tahiti(French Polinesia).png": "c0f0",
	"./Taiwan.png": "ea9f",
	"./Tajikistan.png": "4820",
	"./Tanzania.png": "5f54",
	"./Thailand.png": "0956",
	"./Timor-Leste.png": "a8d2",
	"./Togo.png": "e93f",
	"./Tonga.png": "0ce1",
	"./Trinidad & Tobago.png": "e3bc",
	"./Tunisia.png": "fcb6",
	"./Turkey.png": "54fe",
	"./Turkmenistan.png": "eadb",
	"./Turks and Caicos Islands.png": "fa10",
	"./Tuvalu.png": "836c",
	"./USA.png": "7aef",
	"./Uganda.png": "5807",
	"./Ukraine.png": "026f",
	"./United Arab Emirates.png": "b36a",
	"./United Kingdom(Great Britain).png": "19cb",
	"./United Nations.png": "056c",
	"./Uruguay.png": "abf9",
	"./Uzbekistan.png": "da79",
	"./Vanutau.png": "8d0e",
	"./Vatican City.png": "b3cb",
	"./Venezuela.png": "9e34",
	"./Viet Nam.png": "95a1",
	"./Virgin Islands British.png": "be62",
	"./Virgin Islands US.png": "6554",
	"./Wales.png": "2adc",
	"./Western Sahara.png": "d09b",
	"./Yemen.png": "31da",
	"./Zambia.png": "3d45",
	"./Zimbabwe.png": "c936"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1da8";